module.exports = __webpack_public_path__ + "img/play.367890b5.png";